import Cta from "./landing/cta";
import Faq from "./landing/faq";
import Features from "./landing/features";
import Footer from "./landing/footer";
import Hero from "./landing/hero";
import HowItWorks from "./landing/how-it-works";
import Navbar from "./landing/navbar";
import Pricing from "./landing/pricing";
import Testimonials from "./landing/testimonials";

export default function Home() {
  return (
    <main className="min-h-screen bg-gradient-to-b from-background to-background/80">
      <Navbar />
      <Hero />
      <Features />
      <HowItWorks />
      <Testimonials />
      <Pricing />
      <Faq />
      <Cta />
      <Footer />
    </main>
  );
}
